if (typeof gsap !== "undefined") {
  gsap.defaults({
    ease: Power4.easeOut,
  });
  gsap.config({
    nullTargetWarn: false,
  });

  const plugins = [];
  if (typeof ScrollTrigger !== "undefined") plugins.push(ScrollTrigger);
  if (typeof DrawSVGPlugin !== "undefined") plugins.push(DrawSVGPlugin);
  if (plugins.length) gsap.registerPlugin(...plugins);
}
